import * as IconVip from "assets/common/images/vip";

export const LIST_ICON_VIP = [
  IconVip.IconVip1,
  IconVip.IconVip2,
  IconVip.IconVip3,
  IconVip.IconVip4,
  IconVip.IconVip5,
  IconVip.IconVip6,
  IconVip.IconVip7,
  IconVip.IconVip8,
  IconVip.IconVip9,
  IconVip.IconVip10,
  IconVip.IconVip11,
  IconVip.IconVip12,
  IconVip.IconVip13,
  IconVip.IconVip14,
  IconVip.IconVip15,
  IconVip.IconVip16,
  IconVip.IconVip17,
  IconVip.IconVip18,
  IconVip.IconVip19,
  IconVip.IconVip20,
  IconVip.IconVip21,
  IconVip.IconVip22,
  IconVip.IconVip23,
  IconVip.IconVip24,
  IconVip.IconVip25,
  IconVip.IconVip26,
  IconVip.IconVip27,
  IconVip.IconVip28,
  IconVip.IconVip29,
  IconVip.IconVip30,
  IconVip.IconVip31,
  IconVip.IconVip32,
  IconVip.IconVip33,
  IconVip.IconVip34,
  IconVip.IconVip35,
  IconVip.IconVip36,
  IconVip.IconVip37,
  IconVip.IconVip38,
  IconVip.IconVip39,
  IconVip.IconVip40,
  IconVip.IconVip41,
  IconVip.IconVip42,
  IconVip.IconVip43,
  IconVip.IconVip44,
  IconVip.IconVip45,
  IconVip.IconVip46,
  IconVip.IconVip47,
  IconVip.IconVip48,
  IconVip.IconVip49,
  IconVip.IconVip50,
];
